/// <reference path='Dapi.d.ts' />
import getFirstAncestor from './getFirstAncestor';
/**
 * Triggers resplaceState if an anchor tag was clicked.
 * This applies for anchor tags with no target attribute or target attribute value is neither 'dapi_navigate' nor '_blank'.
 * @param node
 * @param dapi
 * @returns {}
 */
export default function triggerReplaceStateIfAnchorClicked(node, dapi) {
    node.addEventListener("click", (evt) => {
        const isAnchor = (element) => (element.tagName === "A" && (element.attributes["target"] == null ||
            element.attributes["target"] != null && (element.attributes["target"].value !== "dapi_navigate" &&
                element.attributes["target"].value !== "dapi_blank" &&
                element.attributes["target"].value !== "_blank")));
        const anchor = isAnchor(evt.target) ? evt.target
            : getFirstAncestor(evt.target, (element) => {
                return isAnchor(element);
            });
        if (anchor == null ||
            anchor.attributes["href"] == null)
            return;
        const replaceUri = anchor.attributes["href"].value;
        if (!evt.defaultPrevented) {
            dapi.replaceState(replaceUri);
        }
    }, false);
}
;
